<app-toast></app-toast>
<app-delete-confirmation-dialog title="{{ 'shared.delete' | transloco }}?"
    body="{{ 'admin.are_you_sure_delete_item' | transloco }}"></app-delete-confirmation-dialog>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full max-w-ultrawide">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full max-w-ultrawide">
        <app-admin-navigation [isActiveNumber]="12"></app-admin-navigation>
    </div>

    <div class="flex w-full max-w-ultrawide mobile:flex-col desktop:justify-between items-center">
        <div class="flex flex-col gap-2">
            <!-- Header -->
            <div class="flex gap-2 w-full mt-4 max-w-ultrawide">
                <img src="assets/icons/services/chart-line-purple.svg" class="w-[24px] h-[24px]"
                    alt="{{ 'shared.icon' | transloco }}">
                <h1 class="font-bold text-xl">
                    {{ 'admin.indicators' | transloco }}</h1>
            </div>
            <p class="text-neutral-500 self-start mt-2"> {{ 'admin.indicators_desc' | transloco }}</p>
        </div>

        <div class="w-[250px] h-[50px]">
            <app-custom-button buttonText="{{ 'admin.add_indicator' | transloco }}" leadingIcon="assets/icons/add.svg"
                backgroundColor="bg-success" textColor="text-white" borderColor="border-success"
                hoverBorderColor="hover:border-success-600" hoverBackgroundColor="hover:bg-success-600"
                (buttonClick)="createIndicator()"></app-custom-button>
        </div>
    </div>

    <!-- Content -->
    <div class="w-full max-w-ultrawide mt-4 flex flex-col gap-4 py-4" #editCreateRef>

        <!-- Edit/Create-->
        <app-create-edit-indicator [(isOpen)]="isEditCreateOpen" [isEditing]="isEditing" [indicator]="selectedIndicator"
            [toast]="toast" [reloadCallbackFunction]="reloadIndicators"></app-create-edit-indicator>

        <!-- Card -->
        <div class="relative w-full rounded-xl border border-border shadow-md" *ngFor="let indicator of indicators">
            <!-- Top actions (edit/delete) -->
            <div class="absolute right-3 top-3 flex items-center gap-3 text-neutral-400">
                <!-- Edit -->
                <button title="{{ 'settings.button.edit' | transloco }}" class="p-1 rounded hover:bg-secondary-200"
                    (click)="editIndicator(indicator)">
                    <img src="assets/icons/edit.svg" alt="{{ 'settings.button.edit' | transloco }}" class="w-6 h-6" />
                </button>
                <!-- Delete -->
                <button title="{{ 'shared.delete' | transloco }}" (click)="deleteIndicator(indicator)">
                    <svg width="24" height="24" viewBox="0 0 50 50">
                        <circle cx="25" cy="25" r="24" fill="#FF0000" />
                        <image href="assets/icons/delete.svg" x="12" y="12" height="25px" width="25px" />
                    </svg>
                </button>
            </div>

            <!-- Body -->
            <div class="p-6">
                <p class="font-bold text-lg">{{ indicator.name }}</p>

                <!-- Formula -->
                <div class="flex flex-col w-full gap-2 bg-neutral-100 p-2 rounded-md">
                    <p class="text-sm text-neutral-500">{{ 'admin.formula' | transloco }}:</p>
                    <p class="text-sm">{{ indicator.formula }}</p>
                </div>

                <p class="mt-4 text-neutral-500">
                    {{ indicator.description }}
                </p>
            </div>
        </div>
    </div>
</div>